module.exports = __webpack_public_path__ + "static/media/CabinetDoor1_After.5c2f5507.jpg";